export enum EletronicTransferStatus {
  PENDING = 1,
  SENT = 2,
  PAID = 3,
  RETURNED = 4,
  ERROR = 5,
  RECEIVED = 6,
  INTEGRATION_ERROR = 7,
  CHARGEBACK = 8,
  SCHEDULED = 9,
  DENIED = 9,
}
